import { render } from "./TVPVariance.vue?vue&type=template&id=235acc6b"
import script from "./TVPVariance.vue?vue&type=script&lang=js"
export * from "./TVPVariance.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__